import { render, staticRenderFns } from "./MenuProductosComponent.vue?vue&type=template&id=44b450a1&scoped=true"
import script from "./MenuProductosComponent.vue?vue&type=script&lang=js"
export * from "./MenuProductosComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuProductosComponent.vue?vue&type=style&index=0&id=44b450a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b450a1",
  null
  
)

export default component.exports